<template>
    <svg
        fill="none"
        height="20"
        :style="
            withShadow
                ? 'filter: drop-shadow(0px 1px 3px rgba(16, 24, 40, 0.10)) drop-shadow(0px 1px 2px rgba(16, 24, 40, 0.10));'
                : ''
        "
        viewBox="0 0 20 20"
        width="20"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            class="stroke-ds-primary-400"
            d="M7 5L12 10L7 15"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="1.46125"
        />
    </svg>
</template>

<script setup lang="ts">
withDefaults(
    defineProps<{
        withShadow: boolean;
    }>(),
    { withShadow: false },
);
</script>
